import React, {useEffect} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {logout} from 'redux/modules/auth/action';

const PublicRoute = ({children, auth, logout, ...rest}) => {

    // const logoutWithRedirect = async() => {
    //     await logout();
    //     // history.push(location.pathname + location.search);
    // };

    useEffect(() => {
        auth.isAuthenticated && console.log('logging out from publicroute');
        auth.isAuthenticated && logout();

    }, [])

    if(auth.isAuthenticated) return null;
    return (
        <Route
            {...rest}
            render={({location}) => {
                // if(auth.isAuthenticated) {
                //     logout();
                //     return (
                //         <Redirect
                //             to={{
                //                 pathname: location.pathname + location.search,
                //                 // state: {from: location},
                //             }}
                //         />
                //     );
                // } else {
                    return children;
                // }
            }}
        />
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, {logout})(PublicRoute);